var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"KdbArticle",attrs:{"id":("kdb_" + _vm.secret)}},[_c('VSkeletonLoader',{staticStyle:{"max-width":"500px","margin":"0 auto"},attrs:{"type":"article"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }